"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Login = void 0;
var react_1 = __importStar(require("react"));
var neo4j_constants_1 = require("../neo4j.constants");
var login_desktop_1 = require("./login-desktop");
var login_form_1 = require("./login-form");
exports.Login = function (_a) {
    var error = _a.error, onSubmit = _a.onSubmit, props = __rest(_a, ["error", "onSubmit"]);
    // @ts-ignore
    var _b = react_1.useState((props.showProject || props.showProject === undefined) && window.neo4jDesktopApi), showProjectForm = _b[0], setShowProjectForm = _b[1];
    // TODO: Dynamic classes
    var classNames = neo4j_constants_1.globalClassNames.semantic;
    var form;
    if (showProjectForm) {
        form = react_1.default.createElement(login_desktop_1.LoginDesktop, { classNames: classNames, showActive: props.showActive, hide: function () { return setShowProjectForm(false); }, onSubmit: onSubmit });
    }
    else {
        // @ts-ignore
        form = react_1.default.createElement(login_form_1.LoginForm, __assign({ classNames: classNames, showHost: props.showHost, showDatabase: props.showDatabase, onSubmit: onSubmit }, props));
    }
    return (react_1.default.createElement("div", { className: classNames.login },
        react_1.default.createElement("div", { className: classNames.loginContainer },
            props.title,
            react_1.default.createElement("form", { className: classNames.form },
                props.logo,
                error && (react_1.default.createElement("div", { className: classNames.formError }, error.message)),
                form,
                props.details),
            props.footer)));
};
